class MultiDictionary {
    constructor() {
        this.data = {};
    }

    push(key, value) {
        if (!this.data[key]) {
            this.data[key] = [];
        }

        this.data[key].push(value);
    }

    get(key) {
        return this.data[key] || [];
    }
}

class EventDispatcher {
    constructor() {
        this.events = new MultiDictionary();
        this.subscribers = new MultiDictionary();
    }

    subscribe({identifier, subscriber = {}} = {}) {
        this.subscribers.push(identifier, subscriber);
        subscriber.dispatch(this.events.get(identifier));
    }

    dispatch({identifier = '', message = '', data = {}} = {}) {
        const msg = {message, data};
        this.events.push(identifier, msg);
        this.sendMessageToSubscribers({identifier, message: msg});
    }

    sendMessageToSubscribers({identifier, message} = {}) {
        this.subscribers.get(identifier)
            .forEach((subscriber) => subscriber.dispatch([message]));
    }
}

module.exports = new EventDispatcher();
